import { Component, DestroyRef, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { CopyCryptoTokenKeyComponent } from '../copy-crypto-token-key/copy-crypto-token-key';
import { GenerateKeyRequestDto } from 'src/app/shared/services/api/dto/generate-key-request-dto';
import { SpinnerComponent } from 'src/app/shared/components/spinner/spinner.component';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { CryptotokenKeyDataService } from 'src/app/shared/store/features/cryptotoken-keys/cryptotoken-keys.service';
import { tap, catchError, of, finalize } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { extractErrorMessage } from 'src/app/shared/util/extract-error-message';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { ToastrService } from 'ngx-toastr';
import { CopyCryptoTokenDialogData } from './copy-crypto-token-key-dialog.types';

@Component({
  selector: 'app-copy-crypto-token-key-dialog',
  imports: [MatDialogModule, CopyCryptoTokenKeyComponent, SpinnerComponent],
  templateUrl: './copy-crypto-token-key-dialog.html',
  styleUrl: './copy-crypto-token-key-dialog.scss',
})
export class CopyCryptoTokenKeyDialogComponent {
  private destroyRef = inject(DestroyRef);
  private apiService = inject(ApiService);
  private cryptoTokenKeyDataService = inject(CryptotokenKeyDataService);
  private labels =
    inject(LangService).lang.features.cryptotokenlist.details.cryptoTokenKeys;
  private dialogData: CopyCryptoTokenDialogData = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef);
  private toastrService = inject(ToastrService);
  value = this.dialogData.value;
  aliasSuffix = '_copy';

  isCreating = false;

  onCopy(dto: GenerateKeyRequestDto) {
    this.isCreating = true;
    this.apiService
      .createCryptotokenKey(this.value.tokenName, dto)
      .pipe(
        tap(() => {
          this.onSuccess();
        }),
        catchError(error => {
          this.onFail(error);
          return of();
        }),
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.isCreating = false;
        }),
      )
      .subscribe();
  }

  onCancel() {
    this.dialogRef.close();
  }

  private onSuccess() {
    this.toastrService.success(this.labels.toasts.created);
    const tokenName = this.value.tokenName;
    if (tokenName) {
      this.cryptoTokenKeyDataService.clear();
      this.cryptoTokenKeyDataService.ensure(tokenName);
    }
    this.dialogRef.close();
  }

  private onFail(error: unknown) {
    console.error('Key creation error', error);
    const defaultToast = this.labels.toasts.fail;
    const beToast = extractErrorMessage(error);
    this.toastrService.error(beToast || defaultToast);
  }
}
